/**
 * @module storage
 * 色々な状態の保存
 */

const state = {
  selectedArea: '', // 選択中のAreaCode(Tokyo+やFukuokaなど)
  selectedLike: [], // 選択中のLikeCode
  topButton: '', // Topのボタンのどちらを押されたか
  lastRoute: '', // 最後のRoute(Topページが英語か日本語か)
  nextRoute: '', // 次の遷移先(途中にSignInやMyProfileが挟まった場合)
  lastReload: 0, // 最終リロード時間()
}

const getters = {
  selected(state) {
    return {
      area: state.selectedArea,
      like: !state.selectedLike ? [] : state.selectedLike,
    }
  },
  isLocal(state) {
    return state.topButton == 'local'
  },
  fromTop(state) {
    return state.lastRoute === 'Top' || state.lastRoute === 'enTop'
  },
  getNextRoute(state) {
    return state.nextRoute
  },
  isTodayReload(state) {
    return (Date.now() - state.lastReload) < (24 * 60 * 60 * 1000)
  },
}

const mutations = {
  SET_SELECTED_AREA(state, area) {
    state.selectedArea = area
  },
  SET_SELECTED_LIKE(state, val) {
    state.selectedLike.splice(0)
    val.forEach(v => state.selectedLike.push(v))
  },
  SET_TOP_BUTTON(state, val) {
    state.topButton = val
  },
  SET_LAST_ROUTE(state, val) {
    state.lastRoute = val
  },
  SET_NEXT_ROUTE(state, val) {
    state.nextRoute = val
  },
  SET_LAST_RELOAD(state) {
    state.lastReload = Date.now()
  }
}

const actions = {
  setSelectedArea({commit}, val) {
    commit('SET_SELECTED_AREA', val)
  },
  setSelectedLike({commit}, val) {
    commit('SET_SELECTED_LIKE', val)
  },
  setTopButtonLocal({commit}) {
    commit('SET_TOP_BUTTON', 'local')
  },
  setTopButtonTraveler({commit}) {
    commit('SET_TOP_BUTTON', 'traveler')
  },
  setLastRoute({commit}, val) {
    commit('SET_LAST_ROUTE', val)
  },
  clearLastRoute({commit}) {
    commit('SET_LAST_ROUTE', '')
  },
  setNextRoute({commit}, val) {
    commit('SET_NEXT_ROUTE', val)
  },
  clearNextRoute({commit}) {
    commit('SET_NEXT_ROUTE', '')
  },
  setLastReload({commit}) {
    commit('SET_LAST_RELOAD')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
